import { AssessmentInfo } from "../assessment";
import { AssessmentScoring } from "../scoring/scoring";

export const nhptInfo: AssessmentInfo = {
    shortName: "NHPT",
    fullName: "Nine Hole Peg Test",
    reportDescription: `\
<p>Der Nine Hole Peg Test (NHPT) ist ein standardisierter Test zur Bewertung der Feinmotorik und Fingerfertigkeit. Dabei platziert der Patient neun kleine Stifte in vorgebohrte Löcher und entfernt sie anschließend, so schnell wie möglich. Eine kürzere Zeit zeigt eine bessere Fingerfertigkeit und Koordination an.</p>`
}

export const nhptScoring: AssessmentScoring = {
    sided: true,
    icfCategories: ["d440"],
}